<template>
  <li class="scored-asset" :class="{'completed': pak.is_complete}">
    <i class="k-asset-icon" :class="getAssetIcon('pak')" aria-hidden="true"></i>
    <div class="asset-details">
      <router-link :to="{ name: 'pak_ov_instructions', params: { moduleId: moduleId, modulePakId: pak.id }}" class="router-link">
        {{ pak.name }}
      </router-link>
      <k-asset-tags :asset="pak"></k-asset-tags>
      <span v-if="pak.end_date" class="asset-due-date">
        Due: <b>{{ parseTimestamp(pak.end_date, undefined, "do MMM yyyy") }}</b>
      </span>
    </div>
    <i v-if="pak.is_complete" class="fas fa-check" aria-hidden="true"></i>
    <div class="overall-score">
      <k-progress shape="circle" size="xsmall" :percentage="progressPercent" :precision="numberPrecision" ariaLabel="Assignment Score"></k-progress>
    </div>
    <router-link class="view-content btn btn-outlined" :to="{ name: 'pak_ov_instructions', params: { moduleId: moduleId, modulePakId: pak.id }}">
      View content <i class="fas fa-long-arrow-alt-right" aria-hidden="true"></i>
    </router-link>
  </li>
</template>

<script>
import KProgress from '@base-components/k-progress.vue';
import TimeMixin from '@mixins/time-mixins';
import AssetIconMixin from '@mixins/asset-icon-mixin';
import KAssetTags from '@base-components/k-asset-tags.vue';

export default {
  props: {
    pak: {
      type: Object,
      required: true,
    },
    latestScore: {
      type: Number,
      default: null,
    },
  },
  mixins: [TimeMixin, AssetIconMixin],

  components: {
    'k-progress': KProgress,
    KAssetTags,
  },

  computed: {
    moduleId() {
      return this.$route.params.moduleId;
    },
    progressPercent() {
      return this.latestScore !== null ? this.latestScore : 0;
    },
    numberPrecision() {
      if (this.pak.additional_features) {
        return this.pak.additional_features.number_precision;
      }
      return undefined;
    },
  },
};
</script>
